import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { AddressBlockEmail } from "./email";
import type { AddressBlockProps } from "./types";

export function AddressBlockEditor(props: AddressBlockProps) {
	return (
		<EmailComponentWrapper shop={props.shop}>
			<AddressBlockEmail {...props} />
		</EmailComponentWrapper>
	);
}
